// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ywUq","image":"Header_image__137HJ","name":"Header_name__Rz5Gs","info":"Header_info__2GL0M","infoRow":"Header_infoRow__2lXkN"};